package org.hs_soft.runmynesto.pages.home.sub_page.options.component

import androidx.compose.runtime.Composable

import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.model.home.options.cash_register_config.DeviceTypeEnum
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.pages.components.dialog.dialog.AddRecordDialog
import org.hs_soft.runmynesto.pages.components.dialog.dialog.ErrorMsgDialog
import org.hs_soft.runmynesto.pages.components.dialog.dialog.MenuCardAIDialog
import org.hs_soft.runmynesto.pages.home.sub_page.options.component.tabs.restaurant_manager.components.dialogs.AddNewDeviceToCashRegistersDialog
import org.hs_soft.runmynesto.pages.home.sub_page.options.component.tabs.restaurant_manager.components.dialogs.DeleteDialog
import org.hs_soft.runmynesto.pages.home.sub_page.options.component.tabs.restaurant_manager.components.dialogs.AddRestaurantFloorDialog
import org.hs_soft.runmynesto.pages.home.sub_page.options.component.tabs.restaurant_manager.components.dialogs.EditRestaurantFloorDialog
import org.hs_soft.runmynesto.pages.home.sub_page.options.component.tabs.virtual_card.component.dialog.apple.AppleWalletDialog
import org.hs_soft.runmynesto.pages.home.sub_page.options.component.tabs.virtual_card.component.dialog.google.GoogleWalletDialog
import org.hs_soft.runmynesto.pages.home.sub_page.options.mvi.OptionsEvent
import org.hs_soft.runmynesto.pages.home.sub_page.options.mvi.OptionsState
import org.hs_soft.runmynesto.pages.home.sub_page.template.component.tabs.tab_general.component.color_pallet.ColorPallet

@Composable
fun OptionsDialogs(
    state: OptionsState,
    windowSizeMode: WindowSizeModeEnum,
    event: (OptionsEvent) -> Unit
){

    if (state.showAddNewDeviceToCashRegistersDialog){

        AddNewDeviceToCashRegistersDialog(
            windowSizeMode=windowSizeMode,
            loading=state.addNewCashRegisterLoading,
            selectedOffice=state.selectedOffice,
            selectedRegion=state.selectedRegion,
            selectedBranch =state.selectedBranch,
            cashList = state.cashList,
            onDismissDialog = {
                event(OptionsEvent.SetAddNewDeviceToCashRegistersDialogStatus(false))
            },
            onSelectShop = {
                event(OptionsEvent.OnSelectShop(it))
            },
            onSelectRegion = {
                event(OptionsEvent.OnSelectRegion(it))
            },
            onSelectOffice = {
                event(OptionsEvent.OnSelectOffice(it))
            },
            createNewDepartment = { name->
                event(OptionsEvent.CreateNewDepartment(name))
            },
            createNewRegion = {id:String,name:String->
                event(OptionsEvent.CreateNewRegion(
                    name=name,
                    departmentId = id,
                ))
            },
            createNewShop={id:String,name:String->
                event(
                    OptionsEvent.CreateNewShop(
                        name=name,
                        regionId = id
                    )
                )
            },
            createCashRegister = { deviceType: DeviceTypeEnum, name:String, hardwareId:String,
                    settingsCopyId:String, shopId:String, deactivateAllContent:Boolean->
                event(
                    OptionsEvent.CreateCashRegister(
                        deviceType=deviceType,
                        name=name,
                        shopId=shopId,
                        hardwareId=hardwareId,
                        settingsCopyId=settingsCopyId,
                        deactivateAllContent=deactivateAllContent,
                    )
                )

            }
        )
    }

    if (state.showDeleteRestaurantRoomDialog){
        DeleteDialog(
            title = Strings.current().delete,
            description = Strings.current().doYouWantToRemoveThisRoom,
            windowSizeMode=windowSizeMode,
            loading =state.deleteRestaurantRoomLoading,
            onDismissDialog = {
                event(OptionsEvent.SetDeleteRoomDialogStatus(false))
            },
            onSubmitClick = {
                event(OptionsEvent.DeleteRestaurantRoom(
                    roomId =state.selectedRoomId
                ))
            }
        )
    }
    if (state.showDeleteRestaurantFloorDialog){
        DeleteDialog(
            title =Strings.current().delete,
            description =Strings.current().doYouWantToRemoveThisFloor ,
            windowSizeMode=windowSizeMode,
            loading =state.deleteRestaurantFloorLoading,
            onDismissDialog = {
                event(OptionsEvent.SetDeleteFloorDialogStatus(false))
            },
            onSubmitClick = {
                event(OptionsEvent.DeleteRestaurantFloor(
                    floorId =state.selectedFloorId
                ))
            }
        )
    }

    if (state.showAddFloorDialog){

        AddRestaurantFloorDialog(
            windowSizeMode=windowSizeMode,
            selectedProject = state.selectedRestaurantProject,
            loading=state.addRestaurantFloorLoading,
            onDismissDialog = {
                event(OptionsEvent.SetAddRestaurantFloorDialogStatus(false))
            },
            onSubmitClick = {number->
                event(OptionsEvent.CreateRestaurantFloor(number = number))
            },
        )
    }

    if (state.showEditFloorDialog){

        EditRestaurantFloorDialog(
            initialFloorNumber = state.selectedFloorNumberForEdit,
            windowSizeMode=windowSizeMode,
            selectedProject = state.selectedRestaurantProject,
            loading=state.editRestaurantFloorLoading,
            onDismissDialog = {
                event(OptionsEvent.SetEditRestaurantFloorDialogStatus(
                    status = false,
                ))
            },
            onSubmitClick = {number->

                event(OptionsEvent.UpdateRestaurantFloor(
                    number = number,
                    floorId=state.selectedFloorId
                ))
            },
        )

    }

    if (state.showChooseRestaurantTableColorDialog){
        ColorPallet(
            onColorClick = {
                event(OptionsEvent.OnRestaurantDesignTableColorClick(it))
            },
            onBackgroundClick = {
                event(OptionsEvent.SetRestaurantTableColorDialogStatus(false))
            }
        )
    }

    if (state.showVirtualCardColorPalletDialog){
        ColorPallet(
            onColorClick = {
                event(OptionsEvent.OnVirtualCardPalletColorClick(
                    it
                ))
            },
            onBackgroundClick = {
                event(OptionsEvent.SetColorPalletStatus(false))
            }
        )
    }

    if (state.showAddSaleGroupRecordDialog) {
        AddRecordDialog(
            windowSizeMode = windowSizeMode,
            dialogTitle = Strings.current().addNewSaleGroup,
            nameFieldTitle = Strings.current().name,
            numberFieldTitle = Strings.current().number,
            nameHint = Strings.current().enterSaleGroupName,
            numberHint = Strings.current().enterSaleGroupNumber,
            nameValue = state.newRecordName?:"",
            showNumberField =true,
            numberValue = state.newRecordNumber,
            isSubmitClickable = state.isAddNewRecordSubmitClickable,
            loading = state.addSalesGroupLoading,
            onNumberValueChange = {
                event(OptionsEvent.OnChangeRecordNumber(it))
            },
            onNameValueChange = {
                event(OptionsEvent.OnChangeRecordName(it))
            },
            onCancelClick = {
                event(OptionsEvent.OnCancelAddSaleGroupDialogClick)
            },
            onSubmitClick = {
                event(OptionsEvent.OnSubmitAddSaleGroupRecordDialogClick(windowSizeMode))
            }
        ) {
            event(OptionsEvent.OnAddRecordDialogBackgroundClick)
        }
    }

    if (state.showPrinterLocationRecordDialog) {
        AddRecordDialog(
            windowSizeMode = windowSizeMode,
            dialogTitle = Strings.current().addNewLocation,
            nameFieldTitle = Strings.current().name,
            nameHint = Strings.current().enterLocationName,
            numberHint = Strings.current().enterLocationNumber,
            isNameRequired = state.printerLocationIndex==null,
            nameValue = state.newRecordName?:"",
            showNumberField =false,
            isSubmitClickable = if (state.printerLocationIndex==null) state.isAddNewRecordSubmitClickable
                else true,
            loading = state.addNewPrinterLocationLoading,
            onNameValueChange = {
                event(OptionsEvent.OnChangeRecordName(
                    value = it.ifEmpty { null },
                    isNumberOptional = true
                ))
            },
            onCancelClick = {
                event(OptionsEvent.OnCancelAddPrinterLocationDialog)
            },
            onSubmitClick = {
                if (state.printerLocationIndex==null && state.newRecordName?.isNotEmpty() == true){
                    event(OptionsEvent.AddPrinterLocationRecord(
                        location = state.newRecordName
                    ))
                }else if (state.printerLocationIndex!=null){
                    event(OptionsEvent.OnSubmitUpdatePrinterLocationRecordDialogClick(
                        location = state.newRecordName
                    ))
                }

            }
        ) {
            event(OptionsEvent.OnAddRecordDialogBackgroundClick)
        }
    }

    if (state.showGoogleWalletDialog){
        GoogleWalletDialog(
            windowSizeMode=windowSizeMode,
            info=state.virtualCardInfo,
            closeDialog={
                event(OptionsEvent.OnCloseGoogleWallet)
            }
        )

    }
    if (state.showAppleWalletDialog){
        AppleWalletDialog(
            windowSizeMode=windowSizeMode,
            info = state.virtualCardInfo,
            closeDialog = {
                event(OptionsEvent.OnCloseAppleWallet)
            }
        )
    }

    if (state.showGenerateAIMenuCardDialog){
        MenuCardAIDialog(
            windowSizeMode=windowSizeMode,
            menuCardAIGenerated = state.menuCardAIGenerated,
            menuCardPDFFilesUploaded = state.menuCardPDFFilesUploaded,
            menuCardImageFilesUploaded = state.menuCardImageFilesUploaded,
            loading = state.isMenuCardAIGeneratorLoading,
            menuCardSelectedFiles = state.menuCardSelectedFiles?: emptyList(),
            onBackgroundClick = {},
            onCancelGenerateMenuCardClick = {
                event(OptionsEvent.SetGenerateAIMenuCardDialogStatus(false))
            },
            onGenerateMenuCardClick={email, files->
                event(OptionsEvent.GenerateMenuCard(
                    email = email,
                    files=files,
                ))
            },
            info=state.virtualCardInfo,
            onAddPDFFile = {count ->
                event(OptionsEvent.OnAddPDFFile(
                    count = count
                ))
            },
            onAddImageFile = {count ->
                event(OptionsEvent.OnAddImageFile(
                    count = count
                ))
            },
            onMenuCardFilesSelect = {selectedFiles ->
                event(OptionsEvent.OnMenuCardFilesSelect(
                    selectedFiles = selectedFiles
                ))
            },
        )
    }

    if (state.errorInfo!=null){
        ErrorMsgDialog(
            windowSizeMode = windowSizeMode,
            description =state.errorInfo,
            onDismissDialog = {
                event(OptionsEvent.DismissErrorDialog)
            }
        )
    }



}